import { NavLink, useLocation } from 'react-router-dom';
import { Home, Receipt, Wallet, Settings } from 'lucide-react';

const TABS = [
  { to: '/', label: 'Accueil', Icon: Home, exact: true },
  { to: '/depenses/transactions', label: 'Transactions', Icon: Receipt },
  { to: '/previsionnels', label: 'Prévisionnels', Icon: Wallet },
  { to: '/settings', label: 'Paramètres', Icon: Settings },
];

export default function BottomTabBar() {
  const location = useLocation();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-slate-200 flex lg:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      aria-label="Navigation principale"
    >
      {TABS.map(({ to, label, Icon, exact }) => {
        const isActive = exact
          ? location.pathname === to
          : location.pathname === to || location.pathname.startsWith(to + '/');
        return (
          <NavLink
            key={to}
            to={to}
            end={exact}
            className={`flex-1 flex flex-col items-center justify-center gap-0.5 py-2 text-[10px] font-medium transition-colors ${
              isActive ? 'text-slate-900' : 'text-slate-400 hover:text-slate-600'
            }`}
            aria-label={label}
          >
            <Icon
              size={22}
              strokeWidth={isActive ? 2.5 : 1.75}
              aria-hidden
            />
            <span>{label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
